import { handleActions } from "redux-actions";

import { setUsers } from "./actions";

const initialState = {
    isLoadingUsers: false,
    codes: [],
    users: {}
};

export const usersReducer = handleActions(
    {
        [setUsers]: (state, { payload }) => ({
            ...state,
            ...payload
        })
    },
    initialState
);
